import {
  CurrencyCode,
  FreightTerm,
  MoneyInput,
  PaymentTerm,
  Unit,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type QuoteLineItemUpdateInput = {
  id?: string | null;
  itemId?: string | null;
  packageFormat?: string | null;
  quantity?: number | null;
  unit?: Unit | null;
  unitPrice?: MoneyInput | null;
  notes?: string | null;
};

export const quoteUpdateAtom = createMutationAtomFactory(
  'brokerage.quoteUpdate',
  (params: {
    id: string;
    quoteNumber?: string | null;
    accountId?: string | null;
    facilityId?: string | null;
    validUntil?: string | null;
    terms?: string | null;
    notes?: string | null;
    expectedShipDate?: string | null;
    paymentTerm?: PaymentTerm | null;
    paymentCurrency?: CurrencyCode | null;
    freightTerm?: FreightTerm | null;
    freightCoveredByCustomer?: boolean | null;
    lineItems?: QuoteLineItemUpdateInput[];
  }) => ({
    tradeQuoteUpdate: {
      __args: {
        id: params.id,
        input: {
          documentNumber: params.quoteNumber,
          accountId: params.accountId,
          facilityId: params.facilityId,
          validUntil: params.validUntil,
          terms: params.terms,
          notes: params.notes,
          expectedShipDate: params.expectedShipDate,
          paymentTerm: params.paymentTerm,
          paymentCurrency: params.paymentCurrency,
          freightTerm: params.freightTerm,
          freightCoveredByCustomer: params.freightCoveredByCustomer,
          lineItems: params.lineItems,
        },
      },
      id: true,
      documentNumber: true,
      status: true,
      subtotal: {
        amount: true,
        currencyCode: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
